export default __webpack_public_path__ + "static/hero-landing-efe75691b1e7de55a717c3d125638914.jpg";